import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { MotionProvider, OrbitLoader } from "./components/motion";
import AppShell from "./components/AppShell";
import { Watchlist } from "./components/Watchlist";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ResetPassword, { ForgotPassword } from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Positions from "./pages/Positions";
import Holdings from "./pages/Holdings";
import Funds from "./pages/Funds";
import InstrumentPage from "./pages/InstrumentPage";
import AdminApp from "./admin/AdminApp";
import Profile from "./pages/Profile";
import OptionChain from "./pages/OptionChain";
import Strategy from "./pages/Strategy";
import Futures from "./pages/Futures";
import GttAlerts from "./pages/GttAlerts";
import Reports from "./pages/Reports";
import "./App.css";

function PublicShare() {
  const id = window.location.pathname.split("/")[2] || "";
  window.location.replace(`/api/t/${encodeURIComponent(id)}`);
  return null;
}

if (!localStorage.getItem("pt_theme") || localStorage.getItem("pt_theme") === "dark") document.documentElement.classList.add("dark");

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <OrbitLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <MotionProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/t/:id" element={<PublicShare />} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="watchlist" element={<div className="h-[calc(100vh-7rem)]"><Watchlist /></div>} />
            <Route path="orders" element={<Orders />} />
            <Route path="positions" element={<Positions />} />
            <Route path="holdings" element={<Holdings />} />
            <Route path="funds" element={<Funds />} />
            <Route path="instrument/:key" element={<InstrumentPage />} />
            <Route path="profile" element={<Profile />} />
            <Route path="option-chain" element={<OptionChain />} />
            <Route path="strategy" element={<Strategy />} />
            <Route path="futures" element={<Futures />} />
            <Route path="gtt" element={<GttAlerts />} />
            <Route path="reports" element={<Reports />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton visibleToasts={3} duration={4000} gap={8}
        toastOptions={{ className: "!rounded-xl !border-border !shadow-[0_18px_40px_-18px_rgba(0,0,0,0.8)] !backdrop-blur-xl" }} />
      </MotionProvider>
    </AuthProvider>
  );
}
